/**
 * Get user avatar src key
 *
 * @returns User avatar src key from AWS or dummy avatar when not available
 */

import useCurrentUser from '~/hooks/useCurrentUser'

const useAvatarSrc = (): string => {
  const user = useCurrentUser()
  const avatarImgSrcKey = user && user.avatarPngUrl ? user.avatarPngUrl : 'avatar-portraits/hom-default-avatar.png'

  return avatarImgSrcKey
}

export default useAvatarSrc
